import { useEffect, useRef } from 'react'

function Proof() {
  const sectionRef = useRef(null)
  const hasCounted = useRef(false)

  useEffect(() => {
    const section = sectionRef.current
    if (!section || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return
    }

    const stats = section.querySelectorAll('.stat strong')
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || hasCounted.current) {
            return
          }

          hasCounted.current = true
          stats.forEach((el, index) => {
            const original = el.textContent.trim()
            const target = parseInt(original, 10)
            const suffix = original.replace(/[0-9]/g, '')
            const start = performance.now() + index * 90
            const duration = 950

            function frame(now) {
              const progress = Math.max(0, Math.min(1, (now - start) / duration))
              el.textContent = Math.round(target * (1 - Math.pow(1 - progress, 3))) + suffix
              if (progress < 1) {
                requestAnimationFrame(frame)
              }
            }

            requestAnimationFrame(frame)
          })
          observer.disconnect()
        })
      },
      { threshold: 0.35 }
    )

    observer.observe(section)
    return () => observer.disconnect()
  }, [])

  return (
    <section className="proof" ref={sectionRef}>
      <div className="wrap proof-grid">
        <div className="proof-title">Local leadership. International perspective.</div>
        <div className="stat"><strong>2</strong><span>East African market offices</span></div>
        <div className="stat"><strong>200+</strong><span>Years of combined leadership experience</span></div>
        <div className="stat"><strong>3</strong><span>Continents across our active network</span></div>
        <div className="stat"><strong>1</strong><span>Shared standard of technical excellence</span></div>
      </div>
    </section>
  )
}

export default Proof
